export enum Environment {
  PRODUCTION = 'production',
  RELEASE = 'release',
  DEVELOPMENT = 'development',
  TEST = 'test',
  MSW = 'msw',
}
